/**
 * Entry point for the logger utilities.
 * Re-exports the logger instance, Logger class, Sentry helper and types.
 */
export * from './lib/logger.js';
export * from './lib/types/index.js';
export * from './lib/sentry.js';
import { logger as sharedLogger } from './lib/logger.js';
/**
 * Create a named logger. Currently returns the shared logger instance.
 */
export function createLoggerWithSource(_source) {
    // Use the source parameter to satisfy lint rules; feature placeholder for future named logger
    void _source;
    return sharedLogger;
}
/** Log an info-level message. */
export function logInfo(logger, message, meta) {
    logger.info(message, meta);
}
/** Log a warning-level message. */
export function logWarn(logger, message, meta) {
    logger.warn(message, meta);
}
export function logDebug(logger, message, meta) {
    logger.debug(message, meta);
}
/** Log an error-level message. */
export function logError(logger, message, meta) {
    logger.error(message, meta);
}
//# sourceMappingURL=index.js.map